import { state } from '@angular/animations';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { computed, inject } from '@angular/core';
import { AuthStatus } from '../interfaces';


export const isNotAuthenticatedGuard: CanActivateFn = (route, state) => {

  const authService = inject( AuthService );
  const router      = inject( Router );
  const currentUrl = state.url;

  const authStatus = computed(() => authService.authStatus());
  const token = localStorage.getItem('token');

  if (token || authStatus() === AuthStatus.authenticated){
    const urlSaved = localStorage.getItem('url');
    router.navigateByUrl(urlSaved?.toString() || 'sadi');
    return false;
  } else {
    return true;
  }


  // console.log(currentUrl)
  // console.log(authService.authStatus())
  // if (authService.authStatus() === AuthStatus.authenticated ){
  //   console.log(currentUrl)


  //   // router.navigateByUrl(route.params["sadi"]  )
  //   router.navigateByUrl('sadi');
  //   return false;
  // }


  // return true;
}
